import React, { useState, useEffect } from 'react';
import styles from './AddEditProjectModal.module.css';
import { X } from 'lucide-react';
import Loader2 from '../../../components/loader2';

const AddEditProjectModal = ({ isOpen, onClose, project, onSave }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (project) {
      setName(project.name || '');
      setDescription(project.description || '');
    } else {
      setName('');
      setDescription('');
    }
  }, [project, isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    setError(null);

    try {
      // onSave will be a function passed from the parent component
      // that handles the actual API call (create or update)
      await onSave({ 
        name, 
        description,
        status: project ? project.status : 'Planning', // Default status for new projects
      });
      onClose(); // Close modal on success
    } catch (err) {
      setError(err.message || 'An error occurred while saving the project.');
    } finally {
      setIsSaving(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalBackdrop} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className={styles.modalCloseButton}><X size={20} /></button>
        <h2>{project ? 'Edit Project' : 'Create New Project'}</h2>
        
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label htmlFor="projectName">Project Name</label>
            <input
              id="projectName"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Kitchen Renovation"
              required
            />
          </div>
          <div className={styles.formGroup}>
            <label htmlFor="projectDescription">Description</label>
            <textarea
              id="projectDescription"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe your project..."
              rows="4"
            />
          </div>
          
          {error && <p className={styles.errorMessage}>{error}</p>}

          <div className={styles.modalActions}>
            <button type="button" onClick={onClose} className={`${styles.actionButton} ${styles.cancelButton}`}>
              Cancel
            </button>
            <button type="submit" className={`${styles.actionButton} ${styles.saveButton}`} disabled={isSaving}>
              {isSaving ? <Loader2 size="sm" /> : 'Save Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddEditProjectModal;
